export default {
  getRequestPersonal() {
    return {
      name: this.name,
      account_type: this.accountType,
      company_name: this.companyName,
      company_address: this.companyAddress,
      company_site: this.companySite,
      vat: this.vat,
      phone: this.phone,
      additional_info: this.additionalInfo,
      notifications_about_ad_actions: this.adActionsNotifications,
      notifications_about_campaign_actions: this.campaignActionsNotifications,
      notifications_about_campaign_tooltips: this.campaignTooltipsNotifications,
      two_factor_authentication_method: this.twoFactorAuthenticationMethod,
      messengers: this.userMessengers.map((messenger) => ({ nickname: messenger.nickname, messenger_id: messenger.id }))
    }
  },
  accountTypeIsPersonal() {
    return this.accountType === this.accountTypes.personal
  },
  accountTypeIsCompany() {
    return this.accountType === this.accountTypes.company
  },
  userNameOrCompanyName() {
    return this.accountTypeIsCompany ? this.companyName : this.name
  },
  userHasProviderSubscription() {
    return !!this.trafficProviderSubscription.id
  }
}